// WebSocketContext.js
import React, { createContext, useState, useEffect, useReducer, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Alert, Button } from 'react-bootstrap'
import io from "socket.io-client";
import httpClient, { getSocketObject } from "utility/httpClient.util";
// import PNotify from "pnotify/dist/es/PNotify";
// PNotify.defaults.icons = "fontawesome5";
const SocketReducer = (state, { type, payload }) => {
  switch (type) {
    case "SET_SOCKET":
      return {
        ...state,
        socket: payload,
      };
    case "SET_CONNECTED":
      return {
        ...state,
        connected: payload,
      };
    case "SET_CURRENT_CHANNEL":
      return {
        ...state,
        currentChannel: payload,
      };

    default:
      return state;
  }
};

export const WebSocketContext = createContext(null);
const initialState = {
  currentChannel: "",
  connected: false,
  socket:null
};


const LEGACY_SUBSCRIBER = Symbol("legacy-subscriber");

const Channel = (socket, channelName,enableLog=false) => {
  
  const events = {};
  const subscribers = new Set();
  const name = channelName;

  const onEvent = (ev) => {
        
    const { channel, room, event, data } = ev;
    const evName = getEventName(channel || room,event)

    enableLog &&  console.log("Channel::onEvent",events, ev,evName);
    if (event && events[evName]) {
      trigger(evName, ev);
    }
  };

  const getEventName = (localChannelName,eventName) =>{
    return localChannelName+"::"+eventName
  }

  const bind = (eventName, callback, subscriber) => {
    enableLog &&  console.log('Channel::bind',eventName)
    const evName = getEventName(channelName,eventName)

    if (!events[evName]) {
      socket.on(eventName, onEvent);
    }
    
    events[evName] = events[evName] || [];
    if (!events[evName].some((binding) => binding.subscriber === subscriber))
      events[evName].push({ subscriber, callback });
  };

  const unbind = (subscriber) => {
    enableLog && console.log('Channel::unbind');
    Object.keys(events).forEach((eventName) => {
      enableLog && console.log('Channel::unbind::off');
      events[eventName] = events[eventName].filter(
        (binding) => binding.subscriber !== subscriber,
      );
      if (events[eventName].length) return;
      const socketEventName = eventName.slice(channelName.length + 2);
      socket.off(socketEventName, onEvent);
      delete events[eventName];
    });
  };

  const trigger = (eventName, data) => {
    if (events[eventName]) {
      enableLog &&  console.log("Channel::trigger",events[eventName], data);
      events[eventName].forEach(({ callback }) => callback(data));
    }
  };

  const addSubscriber = (subscriber) => {
    subscribers.add(subscriber);
    return {
      name,
      bind: (eventName, callback) => bind(eventName, callback, subscriber),
      unbind: () => unbind(subscriber),
      trigger,
    };
  };
  const removeSubscriber = (subscriber) => {
    unbind(subscriber);
    subscribers.delete(subscriber);
    return subscribers.size;
  };

  return { addSubscriber, removeSubscriber };
};

const eventBCList = ["info", "notice", "success", "error"];
export const WebSocketProvider = ({ children }) => {
  
  const [state, dispatch] = useReducer(SocketReducer, initialState);
  const [socket, setSocket] = useState(null);
  const [enableLog,setEnableLog] = useState(false)

  // Room membership must survive disconnects without depending on render closures.
  const channelsRef = useRef({});
  const channels = channelsRef.current;
  const [globalCallbacks,setGlobalCallbacks] = useState({});

  const enableDebugLog = (enabled = true)=>{
    setEnableLog(Boolean(enabled))
  }

  const subscribe = (channelName, subscriber = LEGACY_SUBSCRIBER) => {
    enableLog && console.log('subscribe',socket.id,channelName)
    if (!channels[channelName]) {
      channels[channelName] = Channel(socket, channelName,enableLog);
      // Send subscription message to server, if necessary
      if (socket?.connected){
        enableLog &&  console.log('subscribe::emit::join',channelName)
        socket.emit("join", channelName);
      }      
    }

    enableLog &&  console.log('subscribe::allCurrentChannel',channels)

    setCurrentChannelDispatch(channelName);
    return channels[channelName].addSubscriber(subscriber);
  };

  const unsubscribe = (channelName, subscriber = LEGACY_SUBSCRIBER) => {
    //debugger
    enableLog &&  console.log('unsubscribe',socket.id,channelName,channels[channelName])
    if (channels[channelName]) {
      if (channels[channelName].removeSubscriber(subscriber)) return;
      if (socket?.connected){
        
          enableLog &&  console.log('unsubscribe::emit::leave',channelName)
         socket.emit("leave", channelName);
      }
      delete channels[channelName];      
    }
    enableLog &&  console.log('unsubscribe::allCurrentChannel',channels)
  };

  const onEvent = (ev) => {
    enableLog && console.log("Provider::onEvent", ev);
    const { channel, event, data } = ev;
    trigger(event, ev);
  };

  const bindBroadcast = (eventName, callback) => {
    enableLog && console.log("bindBroadcast", eventName);
    if (!globalCallbacks[eventName]) {
      socket.on("bc-" + eventName, onEvent);
    }
    globalCallbacks[eventName] = globalCallbacks[eventName] || [];
    globalCallbacks[eventName].push(callback);

    enableLog &&  console.log('bindBroadcast::allCallbacks',globalCallbacks)
    setGlobalCallbacks(globalCallbacks)
    return this;
  };

  const unbindBroadcast = (eventName) => {
    enableLog &&  console.log("unbindBroadcast", eventName);
    if (globalCallbacks[eventName]) {
      socket.off("bc-" + eventName, onEvent);
      delete globalCallbacks[eventName];
    }
    enableLog &&  console.log('unbindBroadcast::allCallbacks',globalCallbacks)
    setGlobalCallbacks(globalCallbacks)
    return this;
  };

  const trigger = (eventName, data) => {
    enableLog &&  console.log("trigger", eventName,globalCallbacks[eventName]);
    if (globalCallbacks[eventName]) {
      globalCallbacks[eventName].forEach((callback) => callback(data));
    }
  };

  const _dispatch = (channel, eventName, data) => {
    if (channels[channel] && channels[channel][eventName]) {
      channels[channel][eventName].forEach((cb) => cb(data));
    }
    if (globalCallbacks[eventName]) {
      globalCallbacks[eventName].forEach((cb) => cb(data));
    }
  };

  //OLD
  const broadcastMessage = (postData) => {
    enableLog && console.log('broadcastMessage',postData)
    return httpClient.post(`/socket/notification/bc-${postData.event}`, postData);
  };

  const pushMessage = (channelName,eventName,postData) => {
    enableLog && console.log('pushMessage',postData)
    return httpClient.post(
      `/socket/notification/push/${channelName}/${eventName}`,
      postData
    );
  };

  useEffect(() => {
    const newSocket = getSocketObject();
    setSocket(newSocket);
    enableLog && console.log(`init ${newSocket.id}`);
    newSocket.on("connect", () => {
      enableLog && console.log(`connect ${newSocket.id}`,newSocket);      
      // Socket.IO creates a new server-side connection after reconnecting.
      // Rejoin every active room before consumers resume receiving events.
      Object.keys(channelsRef.current).forEach((channelName) => {
        newSocket.emit("join", channelName);
      });
      setSocketDispatch(newSocket)
      setConnectedDispatch(true);
    });
    newSocket.on("disconnect", () => {
      enableLog && console.log(`disconnect ${newSocket.id}`);

      setConnectedDispatch(false);
    });

    return () => newSocket.close();
  }, []);

  const setSocketDispatch = (payload) =>
    dispatch({ type: "SET_SOCKET", payload });
  const setConnectedDispatch = (payload) =>
    dispatch({ type: "SET_CONNECTED", payload });
  const setCurrentChannelDispatch = (payload) =>
    dispatch({ type: "SET_CURRENT_CHANNEL", payload });


  return (
    <WebSocketContext.Provider
      value={{
        ...state,        
        subscribe,
        unsubscribe,
        bindBroadcast,
        unbindBroadcast,
        broadcastMessage,
        pushMessage,
        enableDebugLog
      }}
    >
      {/* <SocketContext.Provider value={{...state,socket,joinEvent,leaveEvent,joinNoticeEvent,leaveNoticeEvent}}></SocketContext.Provider> */}        
      {children}
    </WebSocketContext.Provider>
  );
};